import { Fragment, useState } from "react";
import _ from "lodash";

import useMount from '../../hooks/useMount';
import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LabelInput from "../Commons/LabelInput";
import StyleInput from "../Commons/StyleInput";
import OptionInput from "../Commons/OptionInput";
import ValidationInput from "../Commons/ValidationInput";
import { dataValidator } from "../../tools/dataValidator";
import ProcessDesignerFileModal from "./ProcessDesignerFileModal";
import processApi from "../../api/processApi";


import { getLabel, getLanguage } from "../../tools/Dictionary";


const ProcessDesignerModal = (props) =>
{

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const ReadOnly = props.ReadOnly;
  const OnCloseModal = props.OnCloseModal;
  const Data = props.Data;
  const Step = props.Step;
  const ComponentAction = props.ComponentAction;
  const OnConfirm = props.OnConfirm;

  //State
  const [form, setForm] = useState({});
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [modalFile, setModalFile] = useState(false);


  useMount(() =>
  {
    loadData();
  }, []);

  const loadData = () => {

    setForm({
      name: Data.name,
      ...Data.data
    });

  };

  const onChangeInput = (_value, _field) => {

    let tempForm = _.cloneDeep(form);

    tempForm[_field] = _value;

    setForm(tempForm);

  };

  const onChangeCheckBox = (_field) => {


    let tempForm = _.cloneDeep(form);

    tempForm[_field] = !tempForm[_field];

    setForm(tempForm);


  }

  const onChangeName = (e) => {

    let name = e.target.value;

    if (name.length > 50) return; //Check length

    onValidateField("name", name); //Validate field value

    setForm(form => ({
      ...form,
      name
    }));
  };

  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "name";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:50"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };

  const onClickConfirm = () => {

    try{

      if (!onValidateField()) throw new Error(getLabel("App", "The form contains errors. Please check and fix the fields highlighted in red."));
 

      const foundComponentWithName = Step.component.some(c => c._id != Data._id && c.name == form.name);

      if (foundComponentWithName)
      {
        throw new Error(getLabel("ProcessDesignerModal", "The component name already exists"));
      }

      OnConfirm({
        _id: Data._id,
        code: Data.code,
        stepId: Step._id,
        data: form
      });

      OnCloseModal();


    }catch(err){

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

    }


  };


  const displayFields = () =>
  {

    switch (Data.code)
    {
      case "TextZone":
        return displayTextZone();
      case "TextInput": 
        return displayTextInput();
      case "DropDown":
        return displayDropDown();
      case "ActionButton":
        return displayActionButton();
      case "LightCode":
        return displayLightCode();
      case "FileDownload":
        return displayFileDownload();
      case "Superheat":
        return displaySuperheat();
      default:
        return null;
    }

  };

  const displayTextZone = () =>
  {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Text")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:1000"]}
              TextStyle={{ height: "100px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.style}
              Property={"style"}
              Option={{ fontSize: true, fontWeight: true, textDecoration: true }}
              OnChangeValue={onChangeInput}
            />
            {error["style"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["style"]}
              </div>
            }
          </div>
        </div>

      </Fragment>
    );

  };


  const displayTextInput = () =>
  {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:100"]}
              TextStyle={{ height: "40px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.textStyle}
              Property={"textStyle"}
              Option={{ fontSize: true, fontWeight: true, textDecoration: true }}
              OnChangeValue={onChangeInput}
            />
            {error["textStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["textStyle"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Validation")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px", fontSize: "100%" }} >
            <ValidationInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.validation}
              Property={"validation"}
              OnChangeValue={onChangeInput}
            />
            {error["validation"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["validation"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.inputStyle || {}}
              Property={"inputStyle"}
              Option={{ fontSize: true, fontWeight: true, textAlign: true }}
              OnChangeValue={onChangeInput}
            />
            {error["inputStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["inputStyle"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Temperature unit")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <label className="page_switch" style={{ marginRight: "5px", marginBottom: "5px" }}>
              <input
                type="checkbox"
                checked={form.temperatureUnit || false}
                disabled={ReadOnly || !Access.canWrite}
                onChange={() => onChangeCheckBox("temperatureUnit")}
              />
              <span className="page_slider round" />
            </label>
          </div>
        </div>

      </Fragment>
    );

  };

  const displayDropDown = () => {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Text")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:200"]}
              TextStyle={{ height: "80px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.textStyle}
              Property={"textStyle"}
              Option={{ fontSize: true, fontWeight: true, textDecoration: true }}
              OnChangeValue={onChangeInput}
            />
            {error["textStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["textStyle"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Option List")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px", fontSize: "100%" }} >
            <OptionInput
              IsDesktop={IsDesktop}
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.option}
              Property={"option"}
              OnChangeValue={onChangeInput}
            />
            {error["option"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["option"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Validation")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px", fontSize: "100%" }} >
            <ValidationInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.validation}
              Property={"validation"}
              Validation={["required"]}
              OnChangeValue={onChangeInput}
            />
            {error["validation"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["validation"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.inputStyle || {}}
              Property={"inputStyle"}
              Option={{ fontSize: true, fontWeight: true, textAlign: true }}
              OnChangeValue={onChangeInput}
            />
            {error["inputStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["inputStyle"]}
              </div>
            }
          </div>
        </div>

      </Fragment>
    );
  
  };

  const displayLightCode = () => {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:100"]}
              TextStyle={{ height: "40px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Number of light")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "100px" }} >
            <select
              value={form.lightAmount}
              className="page_select_input "
              onChange={(e) => onChangeInput(e.target.value, "lightAmount")}
              style={{ width: "100%", textAlign: "center", fontWeight: "bold" }}
              disabled={!Access.canWrite || ReadOnly}
            >
              {[1,2,3,4,5,6].map((o, index) => (
                <option key={index} value={o}
                  style={{ textAlign: "center", fontWeight: "bold" }}>
                  {o}
                </option>
              ))}
            </select>
          </div>
        </div>
      </ Fragment>
    );
  }

  const displayActionButton = () =>
  {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:50"]}
              TextStyle={{ height: "40px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.inputStyle || {}}
              Property={"inputStyle"}
              Option={{ width: true, fontSize: true, fontWeight: true, backgroundColor: true, color: true }}
              OnChangeValue={onChangeInput}
              Type={"button"}
              ExampleValue={form.text[getLanguage()] || form.text["EN"] || undefined}
            />
            {error["inputStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["inputStyle"]}
              </div>
            }
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesignerModal", "Action")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <select
                value={form.color}
                className="page_select_input "
                onChange={onChangeInput}
                style={{ width: "300px", textAlign: "center", color: (form.color == "white" ? "black" : form.color), fontWeight: "bold" }}
                disabled={!Access.canWrite}
              >
              {ComponentAction.map((o, index) => (
                <option key={index} value={o.code}
                  style={{ textAlign: "center", fontWeight: "bold", color: "black"}}>
                  {o.label[getLanguage()] || o.label["EN"] || ""}
                </option>
              ))}
            </select>
            </div>
          </div>
        </div>

      </Fragment>
    );

  };

  const displayFileDownload = () =>
  {

    console.log(form.processFile)

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Text")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:1000"]}
              TextStyle={{ height: "100px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.style}
              Property={"style"}
              Option={{ fontSize: true, fontWeight: true, textDecoration: true }}
              OnChangeValue={onChangeInput}
            />
            {error["style"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["style"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "File")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <input
              className={"page_text_input " + (form.processFile.id ? "process_modal_clickable_text" : " ") + (error["name"] ? "page_modal_body_col_input_error" : "")}
              value={form.processFile.id ? form.processFile.name + "." + form.processFile.format : ""}
              type="text"
              style={{ width: "100%", height: "30px", backgroundColor: "#f2f2f2", borderColor: "white" }}
              readOnly={true}
              onClick={onClickDownload}
            />
            {(!ReadOnly && Access.canWrite) &&
              <div className="page_button"
                style={{ width: "300px", height: "30px", fontSize: "20px", marginRight: "5px", marginTop: "5px" }}
                title={"Select"}
                onClick={() => setModalFile(true)}
              >
                {getLabel("ProcessDesignerModal", "Select file")}
              </div>
            }
            {error["file"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["file"]}
              </div>
            }
          </div>
        </div>

      </Fragment>
    );

  };

  const displaySuperheat = () =>
  {

    return (
      <Fragment>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <LabelInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.text}
              ListValidation={["max:100"]}
              TextStyle={{ height: "40px" }}
              PreviewMaxLength={400}
              Property={"text"}
              OnChangeValue={onChangeInput}
            />
            {error["text"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["text"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Label Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.textStyle}
              Property={"textStyle"}
              Option={{ fontSize: true, fontWeight: true, textDecoration: true }}
              OnChangeValue={onChangeInput}
            />
            {error["textStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["textStyle"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Validation")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px", fontSize: "100%" }} >
            <ValidationInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.validation}
              Property={"validation"}
              OnChangeValue={onChangeInput}
            />
            {error["validation"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["validation"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Input Style")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <StyleInput
              ReadOnly={!Access.canWrite || ReadOnly}
              Data={form.inputStyle || {}}
              Property={"inputStyle"}
              Option={{ fontSize: true, fontWeight: true, textAlign: true }}
              OnChangeValue={onChangeInput}
            />
            {error["inputStyle"] &&
              <div className="page_modal_body_col_extra page_modal_body_col_error">
                {error["inputStyle"]}
              </div>
            }
          </div>
        </div>
        <div className="page_modal_body_row">
          <div className="page_modal_body_col_title">
            {getLabel("ProcessDesignerModal", "Temperature unit")}
          </div>
          <div className="page_modal_body_col_value" style={{ width: "600px" }} >
            <label className="page_switch" style={{ marginRight: "5px", marginBottom: "5px" }}>
              <input
                type="checkbox"
                checked={form.temperatureUnit || false}
                disabled={ReadOnly || !Access.canWrite}
                onChange={() => onChangeCheckBox("temperatureUnit")}
              />
              <span className="page_slider round" />
            </label>
          </div>
        </div>

      </Fragment>
    );

  };

  const onSelectFile = (_data) =>
  {

    setModalFile(false);

    setForm(form => ({
      ...form,
      processFile: {
        id: _data._id,
        name: _data.name,
        format: _data.format,
        type: _data.type,
        label: _data.label
      }
    }));



  };


  const onClickDownload = async () =>
  {

    try
    {


      let response = await processApi.downloadProcessFile(form.processFile.id);

      const blob = new Blob([response], {
        type: form.processFile.type
      });



      let url = URL.createObjectURL(blob);
      

      // Create an anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = form.processFile.name + "." + form.processFile.format;

      // Append the anchor element to the document body
      document.body.appendChild(a);

      const newwindow = window.open(url, '_blank')

      newwindow.onload = (e) => {

        e.currentTarget.addEventListener("beforeunload", () => {
          URL.revokeObjectURL(url);
        });


      };

      // Cleanup: Remove the anchor element and revoke the temporary URL
      document.body.removeChild(a);
      //URL.revokeObjectURL(url);

      

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  if (!Data || Object.keys(form).length === 0) return null;

  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "1200px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        {modalFile &&
          <ProcessDesignerFileModal 
            IsDesktop={IsDesktop}
            Access={Access}
            ReadOnly={ReadOnly}
            OnCloseModal={() => setModalFile(false)}
            OnSelectFile={onSelectFile}
          />
        }

        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessDesignerModal", "Edit Component")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("ProcessDesignerModal", "Name")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["name"] ? "page_modal_body_col_input_error" : "")}
                value={form.name || ""}
                onChange={onChangeName}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["name"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["name"]}
                </div>
              }
            </div>
          </div>  
          {displayFields()}
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {(Access.canWrite && !ReadOnly) &&
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App", "Confirm")}
              style={{ maxWidth: "200px" }}
              onClick={onClickConfirm}
              disabled={loading}
            />
          }
        </div>
      </div>
    </div>
  );

};

export default ProcessDesignerModal